var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"end"}},[_c('button',{staticClass:"switcher-btn",on:{"click":_vm.goToPolygon}},[_vm._v("\n            Switch to Polygon\n        ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }